<template>
  <div class="detailPage">
    <div class="banner-wrap">
      <van-swipe class="banner_swiper" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in banner" :key="index"
          ><van-image width="100%" height="100%" :src="item.src"
        /></van-swipe-item>
      </van-swipe>
      <div class="enlarge"><i class="iconfont icon-fangda"></i></div>
    </div>
    <div class="goods-info">
      <!-- 标题 -->
      <div class="goods-title">
        Personalized series of women's clothing and accessories
      </div>
      <!-- 其他信息 -->
      <div class="goods-intro">
        <div class="txt"><i>品牌信息：</i><i>广州一批</i></div>
        <div class="txt"><i>生产商：</i><i>广州一批成衣工厂</i></div>
      </div>
      <!-- 价格 -->
      <div class="goods-price-wrap">
        <div class="price-item">
          <div class="txt">零售参考价：</div>
          <div class="con"><span>¥ </span>999,999.99</div>
        </div>
      </div>
    </div>
    <!-- 商品规格 -->
    <div class="line"></div>
    <div class="goods-spec">
      <div class="title">
        <i class="iconfont icon-tubiaozhizuo-"></i> 商品规格
      </div>
      <p>
        商品规格描述，填写在这里，描写商品拥有的基本规格，面料，
        尺寸，以及其他各种相关的信息，设计风格，品牌信息等。
        最多容纳1000字符（500个中文字）
        区块高度有一个基本值，最大值会根据商品规格描述的文字 数量自动匹配。
      </p>
    </div>
    <div class="line"></div>
    <!--商品详情 -->
    <div class="goods-desc-content">
      <div class="title flex-rowl">
        <i class="iconfont icon-tubiaozhizuo-"></i> 商品详情
      </div>
      <div class="main">
        <van-image
          width="100%"
          fit="widthFix"
          src="https://dev.vwingist.com/app_images/mall_smallapp/detail_pic.png"
        />
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="goods-bottom-operation flex-between">
      <div class="arr" @click="handleReturn"><i class="iconfont icon-bottom"></i></div>
      <div class="item flex-rowc" @click="handleOrder(1)">零售订单登记</div>
      <div class="item flex-rowc" @click="handleOrder(2)">销售代客下单</div>
      <div class="item flex-rowc" @click="handleOrder(3)">销售业务派样</div>
    </div>

    <!-- 右侧工具 -->
    <my-tool></my-tool>
  </div>
</template>

<script>
import myTool from "../../../components/tool.vue";
export default {
  name: "cShopDetail",
  components: {
    myTool,
  },
  data() {
    return {
      banner: [
        {
          src: "https://dev.vwingist.com/app_images/mall_smallapp/detail_banner.png",
        },
        {
          src: "https://dev.vwingist.com/app_images/mall_smallapp/detail_banner.png",
        },
        {
          src: "https://dev.vwingist.com/app_images/mall_smallapp/detail_banner.png",
        },
      ],
    };
  },
  methods: {
    handleReturn() {
      this.$router.back()
    },
    handleOrder(type) {
      this.$router.push(`/comSalesIndex/cShopOrder/${type}`)
    }
  }
};
</script>
<style lang="less" scoped>
.detailPage {
  padding-bottom: 260px;
  .title {
    width: 690px;
    margin: auto;
    font-size: 30px;
    color: #3c3c3c;
    text-align: left;
    height: 100px;
    line-height: 100px;
    .iconfont {
      color: #ea3349;
      font-size: 30px;
      font-weight: bold;
    }
  }
  .line {
    width: 100%;
    height: 9px;
    background-color: #f5f5f5;
  }
  .txt1 {
    font-size: 22px;
    color: #a0a0a0;
    margin-right: 35px;
  }
  .txt2 {
    font-size: 22px;
    color: #3c3c3c;
  }
  .banner-wrap {
    margin-bottom: 40px;
    position: relative;
    .banner_swiper {
      height: 100%;
      height: 750px;
    }
    .enlarge {
      position: absolute;
      right: 50px;
      bottom: 40px;
      .icon-fangda {
        font-size: 28px;
        color: #808184;
      }
    }
  }
  .goods-info {
    .goods-title {
      width: 690px;
      margin: auto;
      font-size: 40px;
      color: #3c3c3c;
      line-height: 44px;
    }
    .goods-intro {
      width: 690px;
      margin: 26px auto 41px;
      font-size: 20px;
      color: #969696;
      .txt {
        margin-bottom: 20px;
        text:first-child {
          flex-shrink: 0;
          width: 98px;
          display: inline-block;
          margin-right: 30px;
        }
      }
    }
    .goods-price-wrap {
      width: 690px;
      margin: 0 auto 55px;
      .txt {
        font-size: 22px;
        color: #3c3c3c;
        margin-bottom: 10px;
      }
      .con {
        font-size: 48px;
        color: #3c3c3c;
        margin-left: 10px;
        span {
          font-size: 28px;
        }
      }
    }
  }
  .goods-spec {
    padding: 0 0 55px;
    box-sizing: border-box;
    p {
      width: 670px;
      margin: auto;
      font-size: 24px;
      color: #3c3c3c;
      line-height: 40px;
    }
  }
  .goods-bottom-operation {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    font-size: 24px;
    color: #000000;
    padding: 50px 73px 115px 46px;
    .arr {
      transform: rotate(90deg);
      .iconfont {
        font-size: 40px;
      }
    }
  }
}
</style>